/**
 * Flexible Methods of Learning enums of icons
 */
export enum FlexibleLearningTypeIcon {
  E_LEARNING_ICON = 'eLearning',
  SELF_STUDY_ICON = 'self-study',
  INSTRUCTOR_LED_VIRTUAL_ICON = 'virtual',
}
